<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      @openAddDialog="addInfo()"
      :submitService="submitService"
      addShowPower="/tatrauth/add"
      :submitData="submitData"
      @success="onSuccess"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatName"
        label="机构简称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="oldChnName"
        label="原通道名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="oldLineName"
        label="原线路名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="newChnName"
        label="新通道名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="newLineName"
        label="新线路名称"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="150"
        v-if="
          hasPerm('/tatrauth/edit') ||
          hasPerm('/tatrauth/delete') ||
          hasPerm('/tatrauth/udpStatus')
        "
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="updateInfo(scope.row)"
            v-if="hasPerm('/tatrauth/edit')"
            >修改</el-button
          >
          <el-button
            type="text"
            @click="DeleteInfo(scope.row.id)"
            class="button-color"
            v-if="hasPerm('/tatrauth/delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      :dialogService="dialogService"
      :submitData="dialogData"
      :rules="dialogRules"
      @success="dialogSuccess"
      @close="dialogClose"
      labelWidth="100px"
    >
      <select-organs
        v-model="dialogModel.tatSimpleId"
        :selectValue="dialogModel.tatSimpleId"
        :needAll="false"
        selectWidth="100%"
        organName="原机构"
      ></select-organs>

      <el-form-item label="原通道名称" prop="oldChnId">
        <el-select v-model="dialogModel.oldChnId" filterable>
          <el-option
            v-for="item in chnNameList"
            :key="item.id"
            :label="item.chnName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择原路线" prop="oldLineId">
        <el-select
          v-model="dialogModel.oldLineId"
          :disabled="!dialogModel.oldChnId"
        >
          <el-option
            v-for="item in shortNames"
            :key="item.id"
            :label="item.shortName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <select-organs
        v-model="dialogModel.targetOrganization"
        :selectValue="dialogModel.targetOrganization"
        selectProp="targetOrganization"
        :needAll="false"
        selectWidth="100%"
        organName="目标机构"
      ></select-organs>
      <el-form-item label="新通道名称" prop="newChnId">
        <el-select v-model="dialogModel.newChnId" filterable>
          <el-option
            v-for="item in chnNameList"
            :key="item.id"
            :label="item.chnName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="选择新路线" prop="newLineId">
        <el-select
          v-model="dialogModel.newLineId"
          :disabled="!dialogModel.newChnId"
        >
          <el-option
            v-for="item in shortNamesNew"
            :key="item.id"
            :label="item.shortName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import FormDialog from "../../dialog/FormDialog";
import ElInput from "element-ui/packages/input/src/input";

import ChannelService from "service/ChannelService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "changechannelmanage",
  data() {
    return {
      chnNameList: [],
      shortNames: [],
      shortNamesNew: [],
      formModel: {
        tatSimpleId: "",
      },
      dialogModel: {
        tatSimpleId: "",
        oldChnId: "",
        oldLineId: "",
        newChnId: "",
        newLineId: "",
      },
      tableData: [],
      formDialogTitle: "",
      submitService: ChannelService.tatTaxJumpLineList,
      authId: "",
      dialogRules: {
        tatSimpleId: [
          {
            required: true,
            message: "请选择机构简称",
          },
        ],
        targetOrganization: [
          {
            required: true,
            message: "请选择目标机构简称",
          },
        ],
        oldChnId: [
          {
            required: true,
            message: "请选择原通道名称",
          },
        ],
        oldLineId: [
          {
            required: true,
            message: "请选择原线路名称",
          },
        ],
        newChnId: [
          {
            required: true,
            message: "请选择新通道名称",
          },
        ],
        newLineId: [
          {
            required: true,
            message: "请选择新线路名称",
          },
        ],
      },
      page: {},
      isPage: false,
      flag: false,
    };
  },
  components: {
    ElInput,
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    FormDialog,
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  computed: {
    submitData() {
      this.params = {
        tatSimpleId: this.formModel.tatSimpleId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    dialogService() {
      if (this.authId) {
        return ChannelService.tatTaxJumpLineEdit;
      } else {
        return ChannelService.tatTaxJumpLineAdd;
      }
    },
    dialogData() {
      const params = {
        tatSimpleId: this.dialogModel.tatSimpleId,
        oldChnId: this.dialogModel.oldChnId,
        oldLineId: this.dialogModel.oldLineId,
        newChnId: this.dialogModel.newChnId,
        newLineId: this.dialogModel.newLineId,
      };
      if (this.authId) {
        params.id = this.authId;
      }
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  watch: {
    "dialogModel.oldChnId"(val) {
      if (!this.flag) {
        this.dialogModel.oldLineId = "";
      }
      this.getShortNames(
        "",
        (res) => {
          this.shortNames = res;
          this.flag = false;
        },
        val
      );
    },
    "dialogModel.targetOrganization"(val) {
      this.dialogModel.newChnId = "";
      this.dialogModel.newLineId = "";
    },
    "dialogModel.newChnId"(val) {
      if (!this.flag) {
        this.dialogModel.newLineId = "";
      }
      const tatSimpleId = this.dialogModel.targetOrganization;
      this.getShortNames(
        "",
        (res) => {
          this.shortNamesNew = res;
          this.flag = false;
        },
        val,
        tatSimpleId
      );
    },
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
    this.getchnNameList();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.roleXu.indexOf(vm.userInfo.userName) < 0) {
        vm.showWarming("您暂无该权限");
        vm.$router.back(-1);
      }
    });
  },
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getchnNameList() {
      this.doLoad(
        ChannelService.names,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.chnNameList = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    addInfo() {
      this.formDialogTitle = "添加";
      this.$refs.formDialog.open();
    },
    updateInfo(item) {
      this.authId = item.id;
      this.dialogModel = JSON.parse(JSON.stringify(item));
      this.flag = true;
      this.formDialogTitle = "修改";
      this.$refs.formDialog.open();
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    doDeleteInfo(id) {
      const disabledParams = {
        id: id,
      };
      this.doLoad(
        ChannelService.tatTaxJumpLineDel,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            this.showSuccess(res.respMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    DeleteInfo(id) {
      this.showMsg = "确定删除此通道？";
      this.showConfirm(this.showMsg)
        .then(() => {
          this.doDeleteInfo(id);
        })
        .catch(() => {});
    },
    dialogSuccess(res) {
      this.doCheck(res, (res) => {
        this.showSuccess(res.respMsg);
        this.$refs.formDialog.closeDialog();
        this.getList();
      });
    },
    dialogClose() {
      this.dialogModel = {
        tatSimpleId: "",
        oldChnId: "",
        oldLineId: "",
        newChnId: "",
        newLineId: "",
      };
      this.authId = "";
    },
    dialogOpen() {
      this.getchnNameList();
      if (this.authId) {
        this.getDetail();
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/ChannelManage/ChangeChannelManage.vue